/* eslint-disable react-hooks/exhaustive-deps */
import User from "./User";
import { useEffect } from "react";
import {connect} from "react-redux";
import { requestUsers,getSectionTitle } from "../../redux/actions/actions.js";
import Loading from "../loading/Loading.js";
import React from "react";

const Users = (props) => {
    const { users,isPending,onGetSectionTitle,onRequestUsers} = props;
    useEffect(() => {
        onGetSectionTitle("Users");
        onRequestUsers("");
        return () => {
            let input = document.getElementById("search_button");
            if (input) {
                input.value = "";
            }
        }
    },[])
    return isPending ?
    (
        <div className="main_content_section_main main_content_users_loading_div">
            <Loading type="spinningBubbles" color="rgb(77, 159, 236)" />
        </div>
    ) :
    (
        <div className="main_content_section_main main_content_section">
            <h1 className="users_title main_title">Interesting accounts</h1>
            <p className="users_paragraph main_paragraph">We've collected for you some accounts that you can be interested in.</p>
            <div className="main_content_section_users">
            {
                users.map(user => {
                    return(
                        <User 
                            key={user.id} 
                            firstName={user.firstName} 
                            lastName={user.lastName} 
                            userName={user.userName} 
                            id={user.id} 
                        />
                    )
                })
            }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        users: state.requestUsers.users,
        isPending: state.requestUsers.isPending
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onRequestUsers: (text) => dispatch(requestUsers(text)),
        onGetSectionTitle: (text) => dispatch(getSectionTitle(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Users);